import React, { useEffect, useState } from "react";
import { FxTextFieldBase, FxPassWordTextField } from "../../fxms/inputs/FxTextField";
import { OpClass } from "../../fxms/datas/OpClass";
import { FxUtil } from "../../fxms/datas/FxUtil";
import Box from "@mui/material/Box";
import { v4 as uuidv4 } from 'uuid';
import styled from "styled-components";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxCheckBoxBase } from "../../fxms/inputs/FxCheckBox";
import { FxDataGridBase } from "../../fxms/components/grid/FxDataGrid";
import { FxForm, FxFormButtons } from "../../fxms/inputs/FxForm";
import { FxFooter } from "../../fxms/inputs/FxFooter";
import { getDefaultDate } from "../../fxms/inputs/FxDate";
import { FxCheckBoxWeek } from "../../fxms/inputs/FxCheckBox";
import { FxDateBase } from "../../fxms/inputs/FxDate";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxActionBase } from "../../fxms/actions/FxAction";


import { FxSelectComplex, FxSelectCompany, FxSelectPlant, FxSelectProcTypeCd, FxSelectTimeHourCd, FxSelectEnergy, FxSelectFacility, FxSelectPipe } from "../inputs/VupInputs";

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const UI_SignUp_CU = (props) => {
  const { isLoaded } = props;
  const { selectedDataId, onComplete } = props;
  const [ opId, setOpId ] = React.useState("");
  const [checkedValue, setCheckedValue] = React.useState([{id:0, value:""}]);
  const [startTime, setStartTime] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  //const [opClass, setOpClass] = React.useState(null);
  const [listClass, setListClass] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [complexInloNo, setComplexInloNo] = React.useState(0);
  const [companyInloNo, setCompanyInloNo] = React.useState(0);
  const [plantInloNo, setPlantInloNo] = React.useState(0);
  const [inputDatas, setInputDatas] = React.useState({});
  const [selectedData, setSelectedData] = React.useState({});
  const [open, setOpen] = useState(false); // Dialog 상태 true, false 선택
  const [passwords, setPasswords] = React.useState({
    applyUserPwd: '',
    applyUserPwdAgain: ''
  });

  const handleComplete = () => {
    onComplete(true);
  };

  // 비밀번호 일치 여부 상태
  const [passwordMatch, setPasswordMatch] = React.useState(true);
  const [message, setMessage] = useState("알 수 없는 오류발생"); // 로그인 오류 종류에 따라 메세지 다르게 보여줌

  const validateMandantoryField = () => {

    if( !("applyUserId" in inputDatas) || inputDatas["applyUserId"].length < 6){
      handleOpen();
      setMessage("ID는 최소 6자 이상 입력해야 합니다.");
      return false;
    }

    if( !("applyUserName" in inputDatas) || inputDatas["applyUserName"].length < 2){
      handleOpen();
      setMessage("사용자명은 최소 2자 이상 입력해야 합니다.");
      return false;
    }

    if( !("applyUserMail" in inputDatas) || inputDatas["applyUserMail"].length < 5){
      handleOpen();
      setMessage("이메일을 최소 5자 이상 입력해야 합니다.");
      return false;
    }

    if( !("applyTelNo" in inputDatas) || inputDatas["applyTelNo"].length < 10){
      handleOpen();
      setMessage("전화번호를 최소 10자 이상 입력해야 합니다.");
      return false;
    }

    return true;
  };

  // 비밀번호 유효성 검사 함수
  const validatePassword = (password) => {
    // 길이 체크 (8~16자)
    if (password.length < 8 || password.length > 16) {
      handleOpen();
      setMessage("비밀번호는 8~16자 사이여야 합니다.");
      return false;
    }
    
    // 대문자 포함 체크
    if (!/[A-Z]/.test(password)) {
      handleOpen();
      setMessage("대문자를 포함해야 합니다.");
      return false;
    }
    
    // 소문자 포함 체크
    if (!/[a-z]/.test(password)) {
      handleOpen();
      setMessage("소문자를 포함해야 합니다.");
      return false;
    }
    
    // 숫자 포함 체크
    if (!/[0-9]/.test(password)) {
      handleOpen();
      setMessage("숫자를 포함해야 합니다.");
      return false;
    }
    
    // 특수문자 포함 체크
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      handleOpen();
      setMessage("특수문자를 포함해야 합니다.");
      return false;
    }

    return true;
  };

  // 비밀번호 변경 처리
  const handlePasswordChange = (name, value) => {
    const newPasswords = { ...passwords, [name]: value };
    setPasswords(newPasswords);
    
    // 비밀번호 일치 여부 확인
    if (name === 'applyUserPwd') {
      //validatePassword(value);

      setPasswordMatch(newPasswords.applyUserPwd === value);
    } else if (name === 'applyUserPwdAgain') {
      setPasswordMatch(newPasswords.applyUserPwdAgain === value);
    }
  };

  // Dialog 열기
  const handleOpen = () => {
    setOpen(true);
  };

  // Dialog 닫기
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {

    console.log("UI_SignUp_CU", props);

    if (props.selectedData) {
      let rowData = {};
      rowData = props.selectedData;

      setSelectedData(rowData);

      setInputDatas(rowData);
    }

  }, [props.selectedData]);

  function onChangeValue(id, value, object) {
    let newDatas = { ...inputDatas };

    if (value) {
      newDatas[id] = value;
    } else {
      delete newDatas[id];
    }
    setInputDatas(newDatas);

    console.log("UI_SignUp_CU onChangeValue", newDatas);
  }

  function onClick(name) {
    let newDatas = { ...inputDatas, ...passwords };

    if(!validateMandantoryField()){
      return;
    }

    if(!validatePassword(passwords.applyUserPwd)){
      return;
    }

    if(!passwordMatch || !passwords.applyUserPwdAgain){
      handleOpen();
      setMessage("패스워드가 일치하지 않습니다.");
      return;
    }

    if (name == 'btnCert') {
      // FX_CO_OP_ATTR에 인증 버튼 눌렀을때 API 호출
      let caller = new FxActionBase (
        "fxUrUser/certf/newuserreq",
        "POST",
        "확인을 누르시면 인증번호를 이메일로 발송합니다.",
        "이메일로 인증번호 발송 처리 완료",
        "발송 처리 오류");

      caller.execute(newDatas, function (bret) {
        console.log("UI_SignUp_CU click result ", bret);
      });

    } else if (name == "btnInsert") {
      if(newDatas.certfNum.length != 4){
        handleOpen();
        setMessage("인증번호 4자리를 입력해주세요.");
        return;
      }

      let caller = new FxActionBase(
        "fxUrUser/new",
        "POST",
        "회원가입을 진행할까요? (인증번호 입력 필수)",
        "회원가입 처리 완료",
        "회원가입 처리 오류");
      /*
      caller.errCallback = function() {
        // 모달 팝업 닫기
        handleClose();
        // 부모 컴포넌트로 포커스 이동
        if (props.onClose) {
          props.onClose();
        }
      };
      */
      caller.execute(newDatas, function (bret) {
        console.log("UI_SignUp_CU click result ", bret);
        handleComplete();
      });
    }
  }

  if (isLoaded == false) {
    return <></>
  }

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>
      <FxForm style={{ width: '800px', borderColor: 'green' }}
        cols={['100px', '200px']}
        rows={[
          {
            inputs: ["*ID"
              , <FxTextFieldBase name="applyUserId" onChangeValue={onChangeValue}selectedData={selectedData} width="300px" />
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["*PWD"
              , <input name="applyUserPwd" className={"FxTextField"} type="password" placeholder={"대문자+소문자+숫자+특수문자+총8~16자"} onChange={(e)=> handlePasswordChange(e.target.name, e.target.value)} style={{width: '300px'}} />
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["*PWD(재입력)"
              , <input name="applyUserPwdAgain" className={"FxTextField"} type="password" placeholder={"대문자+소문자+숫자+특수문자+총8~16자"} onChange={(e)=> handlePasswordChange(e.target.name, e.target.value)} style={{width: '300px'}} />
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["*사용자명"
              , <FxTextFieldBase name="applyUserName" onChangeValue={onChangeValue} selectedData={selectedData} width="300px" />,
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["*사용자이메일"
              , <FxTextFieldBase name="applyUserMail" onChangeValue={onChangeValue} selectedData={selectedData} width="300px" />,
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["*전화번호(-포함)"
              , <FxTextFieldBase name="applyTelNo" onChangeValue={onChangeValue} selectedData={selectedData} width="300px" />,
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["인증번호"
              , <FxTextFieldBase name="certfNum" onChangeValue={onChangeValue}selectedData={selectedData} width="300px" />,
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["신청사유메모"
              , <FxTextFieldBase name="applyMemo" onChangeValue={onChangeValue} selectedData={selectedData} width="300px" />,
            ]
            , colspan: [1, 1]
          }
          , {
            inputs: ["담당설치위치명"
              , <FxTextFieldBase name="applyInloName" onChangeValue={onChangeValue} selectedData={selectedData} width="300px" />,
            ]
            , colspan: [1, 1]
          }
        ]
        }
      >
      </FxForm>
      <ButtonWrapper>
        <FxButtonBase name="btnCert" onClick={onClick} text="인증번호 받기" width="150px" />
        <FxButtonBase name="btnInsert" onClick={onClick} text="회원가입" width="150px" />
      </ButtonWrapper>
      <FxFooter />
    </>
  )
}
